import { ArrayHelper } from '../classes/array.helper';
import { IMlbTeamDetails } from '../interfaces/mlb-stats-api/i-team';
import { MlbSportId, RookieLeague } from './mlb-stats-api/base.enum';

// NOTE: DSL (Dominican Summer League) team PKs fetched from MLB Stats API
// All American League (26 teams) and National League (27 teams) DSL affiliates added
// Total: 53 DSL teams across all 30 MLB organizations
// Fetched using: https://statsapi.mlb.com/api/v1/teams/affiliates?teamIds={TEAM_ID}

export const MLB_TEAMS: IMlbTeamDetails[] = [
  {
    teamPk: 110,
    code: 'BAL',
    name: 'Baltimore Orioles',
    shortName: 'Orioles',
    colorHex: '#DF4601',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 110,
  },
  {
    teamPk: 568,
    code: 'NOR',
    name: 'Norfolk Tides',
    shortName: 'Tides',
    colorHex: '#00205B',
    sportId: MlbSportId.AAA,
    orgPk: 110,
  },
  {
    teamPk: 418,
    code: 'BOW',
    name: 'Chesapeake Baysox',
    shortName: 'Baysox',
    colorHex: '#F05023',
    sportId: MlbSportId.AA,
    orgPk: 110,
  },
  {
    teamPk: 488,
    code: 'ABE',
    name: 'Aberdeen IronBirds',
    shortName: 'IronBirds',
    colorHex: '#27251F',
    sportId: MlbSportId.HighA,
    orgPk: 110,
  },
  {
    teamPk: 548,
    code: 'DEL',
    name: 'Delmarva Shorebirds',
    shortName: 'Shorebirds',
    colorHex: '#00205B',
    sportId: MlbSportId.SingleA,
    orgPk: 110,
  },
  {
    teamPk: 599,
    code: 'FCL-BAL',
    name: 'FCL Orioles',
    shortName: 'FCL Orioles',
    colorHex: '#DF4601',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 110,
  },
  {
    teamPk: 621,
    code: 'DSL-BAL-BLK',
    name: 'DSL Orioles Black',
    shortName: 'DSL Orioles Black',
    colorHex: '#DF4601',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 110,
  },
  {
    teamPk: 3130,
    code: 'DSL-BAL-ORG',
    name: 'DSL Orioles Orange',
    shortName: 'DSL Orioles Orange',
    colorHex: '#DF4601',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 110,
  },
  {
    teamPk: 111,
    code: 'BOS',
    name: 'Boston Red Sox',
    shortName: 'Red Sox',
    colorHex: '#BD3039',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 111,
  },
  {
    teamPk: 533,
    code: 'WOR',
    name: 'Worcester Red Sox',
    shortName: 'WooSox',
    colorHex: '#BD3039',
    sportId: MlbSportId.AAA,
    orgPk: 111,
  },
  {
    teamPk: 546,
    code: 'POR',
    name: 'Portland Sea Dogs',
    shortName: 'Sea Dogs',
    colorHex: '#002D72',
    sportId: MlbSportId.AA,
    orgPk: 111,
  },
  {
    teamPk: 428,
    code: 'GRN',
    name: 'Greenville Drive',
    shortName: 'Drive',
    colorHex: '#0C2340',
    sportId: MlbSportId.HighA,
    orgPk: 111,
  },
  {
    teamPk: 414,
    code: 'SAL',
    name: 'Salem Red Sox',
    shortName: 'Red Sox',
    colorHex: '#BD3039',
    sportId: MlbSportId.SingleA,
    orgPk: 111,
  },
  {
    teamPk: 471,
    code: 'FCL-BOS',
    name: 'FCL Red Sox',
    shortName: 'FCL Red Sox',
    colorHex: '#BD3039',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 111,
  },
  {
    teamPk: 626,
    code: 'DSL-BOS-BLU',
    name: 'DSL Red Sox Blue',
    shortName: 'DSL Red Sox Blue',
    colorHex: '#BD3039',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 111,
  },
  {
    teamPk: 627,
    code: 'DSL-BOS-RED',
    name: 'DSL Red Sox Red',
    shortName: 'DSL Red Sox Red',
    colorHex: '#BD3039',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 111,
  },
  {
    teamPk: 147,
    code: 'NYY',
    name: 'New York Yankees',
    shortName: 'Yankees',
    colorHex: '#0C2340',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 147,
  },
  {
    teamPk: 531,
    code: 'SWB',
    name: 'Scranton/Wilkes-Barre RailRiders',
    shortName: 'RailRiders',
    colorHex: '#0C2340',
    sportId: MlbSportId.AAA,
    orgPk: 147,
  },
  {
    teamPk: 1956,
    code: 'SOM',
    name: 'Somerset Patriots',
    shortName: 'Patriots',
    colorHex: '#002D62',
    sportId: MlbSportId.AA,
    orgPk: 147,
  },
  {
    teamPk: 537,
    code: 'HV',
    name: 'Hudson Valley Renegades',
    shortName: 'Renegades',
    colorHex: '#00205B',
    sportId: MlbSportId.HighA,
    orgPk: 147,
  },
  {
    teamPk: 587,
    code: 'TAM',
    name: 'Tampa Tarpons',
    shortName: 'Tarpons',
    colorHex: '#00205B',
    sportId: MlbSportId.SingleA,
    orgPk: 147,
  },
  {
    teamPk: 475,
    code: 'FCL-NYY',
    name: 'FCL Yankees',
    shortName: 'FCL Yankees',
    colorHex: '#0C2340',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 147,
  },
  {
    teamPk: 635,
    code: 'DSL-NYY',
    name: 'DSL NYY Yankees',
    shortName: 'DSL Yankees',
    colorHex: '#0C2340',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 147,
  },
  {
    teamPk: 634,
    code: 'DSL-NYY-2',
    name: 'DSL NYY Bombers',
    shortName: 'DSL Bombers',
    colorHex: '#0C2340',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 147,
  },
  {
    teamPk: 139,
    code: 'TB',
    name: 'Tampa Bay Rays',
    shortName: 'Rays',
    colorHex: '#092C5C',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 139,
  },
  {
    teamPk: 234,
    code: 'DUR',
    name: 'Durham Bulls',
    shortName: 'Bulls',
    colorHex: '#00205B',
    sportId: MlbSportId.AAA,
    orgPk: 139,
  },
  {
    teamPk: 421,
    code: 'MTG',
    name: 'Montgomery Biscuits',
    shortName: 'Biscuits',
    colorHex: '#00205B',
    sportId: MlbSportId.AA,
    orgPk: 139,
  },
  {
    teamPk: 2498,
    code: 'BG',
    name: 'Bowling Green Hot Rods',
    shortName: 'Hot Rods',
    colorHex: '#C8102E',
    sportId: MlbSportId.HighA,
    orgPk: 139,
  },
  {
    teamPk: 233,
    code: 'CHA',
    name: 'Charleston RiverDogs',
    shortName: 'RiverDogs',
    colorHex: '#002D72',
    sportId: MlbSportId.SingleA,
    orgPk: 139,
  },
  {
    teamPk: 2003,
    code: 'FCL-TB',
    name: 'FCL Rays',
    shortName: 'FCL Rays',
    colorHex: '#092C5C',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 139,
  },
  {
    teamPk: 1611,
    code: 'DSL-TB',
    name: 'DSL Rays',
    shortName: 'DSL Rays',
    colorHex: '#092C5C',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 139,
  },
  {
    teamPk: 5086,
    code: 'DSL-TB-2',
    name: 'DSL Tampa Bay',
    shortName: 'DSL Tampa Bay',
    colorHex: '#092C5C',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 139,
  },
  {
    teamPk: 141,
    code: 'TOR',
    name: 'Toronto Blue Jays',
    shortName: 'Blue Jays',
    colorHex: '#134A8E',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 141,
  },
  {
    teamPk: 422,
    code: 'BUF',
    name: 'Buffalo Bisons',
    shortName: 'Bisons',
    colorHex: '#C8102E',
    sportId: MlbSportId.AAA,
    orgPk: 141,
  },
  {
    teamPk: 463,
    code: 'NH',
    name: 'New Hampshire Fisher Cats',
    shortName: 'Fisher Cats',
    colorHex: '#00205B',
    sportId: MlbSportId.AA,
    orgPk: 141,
  },
  {
    teamPk: 435,
    code: 'VAN',
    name: 'Vancouver Canadians',
    shortName: 'Canadians',
    colorHex: '#C8102E',
    sportId: MlbSportId.HighA,
    orgPk: 141,
  },
  {
    teamPk: 424,
    code: 'DUN',
    name: 'Dunedin Blue Jays',
    shortName: 'Blue Jays',
    colorHex: '#134A8E',
    sportId: MlbSportId.SingleA,
    orgPk: 141,
  },
  {
    teamPk: 1390,
    code: 'FCL-TOR',
    name: 'FCL Blue Jays',
    shortName: 'FCL Blue Jays',
    colorHex: '#134A8E',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 141,
  },
  {
    teamPk: 604,
    code: 'DSL-TOR-BLU',
    name: 'DSL Blue Jays Blue',
    shortName: 'DSL Blue Jays Blue',
    colorHex: '#134A8E',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 141,
  },
  {
    teamPk: 1610,
    code: 'DSL-TOR-RED',
    name: 'DSL Blue Jays Red',
    shortName: 'DSL Blue Jays Red',
    colorHex: '#134A8E',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 141,
  },
  {
    teamPk: 145,
    code: 'CHW',
    name: 'Chicago White Sox',
    shortName: 'White Sox',
    colorHex: '#27251F',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 145,
  },
  {
    teamPk: 494,
    code: 'CLT',
    name: 'Charlotte Knights',
    shortName: 'Knights',
    colorHex: '#27251F',
    sportId: MlbSportId.AAA,
    orgPk: 145,
  },
  {
    teamPk: 247,
    code: 'BIR',
    name: 'Birmingham Barons',
    shortName: 'Barons',
    colorHex: '#27251F',
    sportId: MlbSportId.AA,
    orgPk: 145,
  },
  {
    teamPk: 580,
    code: 'WS',
    name: 'Winston-Salem Dash',
    shortName: 'Dash',
    colorHex: '#4B2E83',
    sportId: MlbSportId.HighA,
    orgPk: 145,
  },
  {
    teamPk: 487,
    code: 'KAN',
    name: 'Kannapolis Cannon Ballers',
    shortName: 'Cannon Ballers',
    colorHex: '#002D72',
    sportId: MlbSportId.SingleA,
    orgPk: 145,
  },
  {
    teamPk: 1997,
    code: 'ACL-CHW',
    name: 'ACL White Sox',
    shortName: 'ACL White Sox',
    colorHex: '#27251F',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 145,
  },
  {
    teamPk: 633,
    code: 'DSL-CHW',
    name: 'DSL White Sox',
    shortName: 'DSL White Sox',
    colorHex: '#27251F',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 145,
  },
  {
    teamPk: 114,
    code: 'CLE',
    name: 'Cleveland Guardians',
    shortName: 'Guardians',
    colorHex: '#E31937',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 114,
  },
  {
    teamPk: 445,
    code: 'COL',
    name: 'Columbus Clippers',
    shortName: 'Clippers',
    colorHex: '#00205B',
    sportId: MlbSportId.AAA,
    orgPk: 114,
  },
  {
    teamPk: 402,
    code: 'AKR',
    name: 'Akron RubberDucks',
    shortName: 'RubberDucks',
    colorHex: '#00205B',
    sportId: MlbSportId.AA,
    orgPk: 114,
  },
  {
    teamPk: 437,
    code: 'LC',
    name: 'Lake County Captains',
    shortName: 'Captains',
    colorHex: '#C8102E',
    sportId: MlbSportId.HighA,
    orgPk: 114,
  },
  {
    teamPk: 481,
    code: 'LYN',
    name: 'Lynchburg Hillcats',
    shortName: 'Hillcats',
    colorHex: '#C8102E',
    sportId: MlbSportId.SingleA,
    orgPk: 114,
  },
  {
    teamPk: 5374,
    code: 'ACL-CLE',
    name: 'ACL Guardians',
    shortName: 'ACL Guardians',
    colorHex: '#E31937',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 114,
  },
  {
    teamPk: 5506,
    code: 'DSL-CLE-GOR',
    name: 'DSL CLE Goryl',
    shortName: 'DSL CLE Goryl',
    colorHex: '#E31937',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 114,
  },
  {
    teamPk: 616,
    code: 'DSL-CLE-MEN',
    name: 'DSL CLE Mendoza',
    shortName: 'DSL CLE Mendoza',
    colorHex: '#E31937',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 114,
  },
  {
    teamPk: 116,
    code: 'DET',
    name: 'Detroit Tigers',
    shortName: 'Tigers',
    colorHex: '#0C2340',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 116,
  },
  {
    teamPk: 512,
    code: 'TOL',
    name: 'Toledo Mud Hens',
    shortName: 'Mud Hens',
    colorHex: '#FFD100',
    sportId: MlbSportId.AAA,
    orgPk: 116,
  },
  {
    teamPk: 106,
    code: 'ERI',
    name: 'Erie SeaWolves',
    shortName: 'SeaWolves',
    colorHex: '#002D72',
    sportId: MlbSportId.AA,
    orgPk: 116,
  },
  {
    teamPk: 582,
    code: 'WM',
    name: 'West Michigan Whitecaps',
    shortName: 'Whitecaps',
    colorHex: '#00205B',
    sportId: MlbSportId.HighA,
    orgPk: 116,
  },
  {
    teamPk: 570,
    code: 'LAK',
    name: 'Lakeland Flying Tigers',
    shortName: 'Flying Tigers',
    colorHex: '#0C2340',
    sportId: MlbSportId.SingleA,
    orgPk: 116,
  },
  {
    teamPk: 473,
    code: 'FCL-DET',
    name: 'FCL Tigers',
    shortName: 'FCL Tigers',
    colorHex: '#0C2340',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 116,
  },
  {
    teamPk: 631,
    code: 'DSL-DET-1',
    name: 'DSL Tigers 1',
    shortName: 'DSL Tigers 1',
    colorHex: '#0C2340',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 116,
  },
  {
    teamPk: 2132,
    code: 'DSL-DET-2',
    name: 'DSL Tigers 2',
    shortName: 'DSL Tigers 2',
    colorHex: '#0C2340',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 116,
  },
  {
    teamPk: 118,
    code: 'KC',
    name: 'Kansas City Royals',
    shortName: 'Royals',
    colorHex: '#004687',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 118,
  },
  {
    teamPk: 541,
    code: 'OMA',
    name: 'Omaha Storm Chasers',
    shortName: 'Storm Chasers',
    colorHex: '#004687',
    sportId: MlbSportId.AAA,
    orgPk: 118,
  },
  {
    teamPk: 1350,
    code: 'NWA',
    name: 'Northwest Arkansas Naturals',
    shortName: 'Naturals',
    colorHex: '#004687',
    sportId: MlbSportId.AA,
    orgPk: 118,
  },
  {
    teamPk: 565,
    code: 'QC',
    name: 'Quad Cities River Bandits',
    shortName: 'River Bandits',
    colorHex: '#004687',
    sportId: MlbSportId.HighA,
    orgPk: 118,
  },
  {
    teamPk: 3705,
    code: 'COL',
    name: 'Columbia Fireflies',
    shortName: 'Fireflies',
    colorHex: '#002D72',
    sportId: MlbSportId.SingleA,
    orgPk: 118,
  },
  {
    teamPk: 412,
    code: 'ACL-KC',
    name: 'ACL Royals',
    shortName: 'ACL Royals',
    colorHex: '#004687',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 118,
  },
  {
    teamPk: 630,
    code: 'DSL-KC-VEN',
    name: 'DSL Royals Ventura',
    shortName: 'DSL Royals Ventura',
    colorHex: '#004687',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 118,
  },
  {
    teamPk: 2128,
    code: 'DSL-KC-FOR',
    name: 'DSL Royals Fortuna',
    shortName: 'DSL Royals Fortuna',
    colorHex: '#004687',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 118,
  },
  {
    teamPk: 142,
    code: 'MIN',
    name: 'Minnesota Twins',
    shortName: 'Twins',
    colorHex: '#002B5C',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 142,
  },
  {
    teamPk: 1960,
    code: 'STP',
    name: 'St. Paul Saints',
    shortName: 'Saints',
    colorHex: '#FFD100',
    sportId: MlbSportId.AAA,
    orgPk: 142,
  },
  {
    teamPk: 3898,
    code: 'WIC',
    name: 'Wichita Wind Surge',
    shortName: 'Wind Surge',
    colorHex: '#002D72',
    sportId: MlbSportId.AA,
    orgPk: 142,
  },
  {
    teamPk: 492,
    code: 'CR',
    name: 'Cedar Rapids Kernels',
    shortName: 'Kernels',
    colorHex: '#002D72',
    sportId: MlbSportId.HighA,
    orgPk: 142,
  },
  {
    teamPk: 509,
    code: 'FTM',
    name: 'Fort Myers Mighty Mussels',
    shortName: 'Mighty Mussels',
    colorHex: '#C8102E',
    sportId: MlbSportId.SingleA,
    orgPk: 142,
  },
  {
    teamPk: 474,
    code: 'FCL-MIN',
    name: 'FCL Twins',
    shortName: 'FCL Twins',
    colorHex: '#002B5C',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 142,
  },
  {
    teamPk: 632,
    code: 'DSL-MIN',
    name: 'DSL Twins',
    shortName: 'DSL Twins',
    colorHex: '#002B5C',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 142,
  },
  {
    teamPk: 117,
    code: 'HOU',
    name: 'Houston Astros',
    shortName: 'Astros',
    colorHex: '#002D62',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 117,
  },
  {
    teamPk: 5434,
    code: 'SL',
    name: 'Sugar Land Space Cowboys',
    shortName: 'Space Cowboys',
    colorHex: '#002D62',
    sportId: MlbSportId.AAA,
    orgPk: 117,
  },
  {
    teamPk: 482,
    code: 'CC',
    name: 'Corpus Christi Hooks',
    shortName: 'Hooks',
    colorHex: '#002D62',
    sportId: MlbSportId.AA,
    orgPk: 117,
  },
  {
    teamPk: 573,
    code: 'ASH',
    name: 'Asheville Tourists',
    shortName: 'Tourists',
    colorHex: '#002D72',
    sportId: MlbSportId.HighA,
    orgPk: 117,
  },
  {
    teamPk: 3712,
    code: 'FAY',
    name: 'Fayetteville Woodpeckers',
    shortName: 'Woodpeckers',
    colorHex: '#C8102E',
    sportId: MlbSportId.SingleA,
    orgPk: 117,
  },
  {
    teamPk: 1998,
    code: 'FCL-HOU',
    name: 'FCL Astros',
    shortName: 'FCL Astros',
    colorHex: '#002D62',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 117,
  },
  {
    teamPk: 601,
    code: 'DSL-HOU-BLU',
    name: 'DSL Astros Blue',
    shortName: 'DSL Astros Blue',
    colorHex: '#002D62',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 117,
  },
  {
    teamPk: 5005,
    code: 'DSL-HOU-ORG',
    name: 'DSL Astros Orange',
    shortName: 'DSL Astros Orange',
    colorHex: '#002D62',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 117,
  },
  {
    teamPk: 108,
    code: 'LAA',
    name: 'Los Angeles Angels',
    shortName: 'Angels',
    colorHex: '#BA0021',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 108,
  },
  {
    teamPk: 561,
    code: 'SL',
    name: 'Salt Lake Bees',
    shortName: 'Bees',
    colorHex: '#FFD100',
    sportId: MlbSportId.AAA,
    orgPk: 108,
  },
  {
    teamPk: 559,
    code: 'RC',
    name: 'Rocket City Trash Pandas',
    shortName: 'Trash Pandas',
    colorHex: '#8DC8E8',
    sportId: MlbSportId.AA,
    orgPk: 108,
  },
  {
    teamPk: 460,
    code: 'TC',
    name: 'Tri-City Dust Devils',
    shortName: 'Dust Devils',
    colorHex: '#BA0021',
    sportId: MlbSportId.HighA,
    orgPk: 108,
  },
  {
    teamPk: 401,
    code: 'IE',
    name: 'Inland Empire 66ers',
    shortName: '66ers',
    colorHex: '#C8102E',
    sportId: MlbSportId.SingleA,
    orgPk: 108,
  },
  {
    teamPk: 404,
    code: 'ACL-LAA',
    name: 'ACL Angels',
    shortName: 'ACL Angels',
    colorHex: '#BA0021',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 108,
  },
  {
    teamPk: 600,
    code: 'DSL-LAA',
    name: 'DSL Angels',
    shortName: 'DSL Angels',
    colorHex: '#BA0021',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 108,
  },
  {
    teamPk: 133,
    code: 'OAK',
    name: 'Oakland Athletics',
    shortName: 'Athletics',
    colorHex: '#003831',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 133,
  },
  {
    teamPk: 400,
    code: 'LV',
    name: 'Las Vegas Aviators',
    shortName: 'Aviators',
    colorHex: '#C8102E',
    sportId: MlbSportId.AAA,
    orgPk: 133,
  },
  {
    teamPk: 237,
    code: 'MID',
    name: 'Midland RockHounds',
    shortName: 'RockHounds',
    colorHex: '#003831',
    sportId: MlbSportId.AA,
    orgPk: 133,
  },
  {
    teamPk: 499,
    code: 'LAN',
    name: 'Lansing Lugnuts',
    shortName: 'Lugnuts',
    colorHex: '#002D72',
    sportId: MlbSportId.HighA,
    orgPk: 133,
  },
  {
    teamPk: 524,
    code: 'STO',
    name: 'Stockton Ports',
    shortName: 'Ports',
    colorHex: '#003831',
    sportId: MlbSportId.SingleA,
    orgPk: 133,
  },
  {
    teamPk: 5426,
    code: 'ACL-OAK',
    name: 'ACL Athletics',
    shortName: 'ACL Athletics',
    colorHex: '#003831',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 133,
  },
  {
    teamPk: 602,
    code: 'DSL-OAK',
    name: 'DSL Athletics',
    shortName: 'DSL Athletics',
    colorHex: '#003831',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 133,
  },
  {
    teamPk: 136,
    code: 'SEA',
    name: 'Seattle Mariners',
    shortName: 'Mariners',
    colorHex: '#0C2C56',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 136,
  },
  {
    teamPk: 529,
    code: 'TAC',
    name: 'Tacoma Rainiers',
    shortName: 'Rainiers',
    colorHex: '#00205B',
    sportId: MlbSportId.AAA,
    orgPk: 136,
  },
  {
    teamPk: 574,
    code: 'ARK',
    name: 'Arkansas Travelers',
    shortName: 'Travelers',
    colorHex: '#002D72',
    sportId: MlbSportId.AA,
    orgPk: 136,
  },
  {
    teamPk: 403,
    code: 'EVE',
    name: 'Everett AquaSox',
    shortName: 'AquaSox',
    colorHex: '#00A88E',
    sportId: MlbSportId.HighA,
    orgPk: 136,
  },
  {
    teamPk: 515,
    code: 'MOD',
    name: 'Modesto Nuts',
    shortName: 'Nuts',
    colorHex: '#C8102E',
    sportId: MlbSportId.SingleA,
    orgPk: 136,
  },
  {
    teamPk: 409,
    code: 'ACL-SEA',
    name: 'ACL Mariners',
    shortName: 'ACL Mariners',
    colorHex: '#0C2C56',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 136,
  },
  {
    teamPk: 618,
    code: 'DSL-SEA',
    name: 'DSL Mariners',
    shortName: 'DSL Mariners',
    colorHex: '#0C2C56',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 136,
  },
  {
    teamPk: 140,
    code: 'TEX',
    name: 'Texas Rangers',
    shortName: 'Rangers',
    colorHex: '#003278',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 140,
  },
  {
    teamPk: 102,
    code: 'RR',
    name: 'Round Rock Express',
    shortName: 'Express',
    colorHex: '#C8102E',
    sportId: MlbSportId.AAA,
    orgPk: 140,
  },
  {
    teamPk: 540,
    code: 'FRI',
    name: 'Frisco RoughRiders',
    shortName: 'RoughRiders',
    colorHex: '#C8102E',
    sportId: MlbSportId.AA,
    orgPk: 140,
  },
  {
    teamPk: 448,
    code: 'HIC',
    name: 'Hickory Crawdads',
    shortName: 'Crawdads',
    colorHex: '#C8102E',
    sportId: MlbSportId.SingleA,
    orgPk: 140,
  },
  {
    teamPk: 485,
    code: 'DE',
    name: 'Down East Wood Ducks',
    shortName: 'Wood Ducks',
    colorHex: '#C8102E',
    sportId: MlbSportId.SingleA,
    orgPk: 140,
  },
  {
    teamPk: 411,
    code: 'ACL-TEX',
    name: 'ACL Rangers',
    shortName: 'ACL Rangers',
    colorHex: '#003278',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 140,
  },
  {
    teamPk: 625,
    code: 'DSL-TEX-BLU',
    name: 'DSL Rangers Blue',
    shortName: 'DSL Rangers Blue',
    colorHex: '#003278',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 140,
  },
  {
    teamPk: 2413,
    code: 'DSL-TEX-RED',
    name: 'DSL Rangers Red',
    shortName: 'DSL Rangers Red',
    colorHex: '#003278',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 140,
  },
  {
    teamPk: 144,
    code: 'ATL',
    name: 'Atlanta Braves',
    shortName: 'Braves',
    colorHex: '#CE1141',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 144,
  },
  {
    teamPk: 431,
    code: 'GWN',
    name: 'Gwinnett Stripers',
    shortName: 'Stripers',
    colorHex: '#00205B',
    sportId: MlbSportId.AAA,
    orgPk: 144,
  },
  {
    teamPk: 430,
    code: 'MIS',
    name: 'Mississippi Braves',
    shortName: 'M-Braves',
    colorHex: '#00205B',
    sportId: MlbSportId.AA,
    orgPk: 144,
  },
  {
    teamPk: 432,
    code: 'ROM',
    name: 'Rome Emperors',
    shortName: 'Emperors',
    colorHex: '#00205B',
    sportId: MlbSportId.HighA,
    orgPk: 144,
  },
  {
    teamPk: 478,
    code: 'AUG',
    name: 'Augusta GreenJackets',
    shortName: 'GreenJackets',
    colorHex: '#006B3F',
    sportId: MlbSportId.SingleA,
    orgPk: 144,
  },
  {
    teamPk: 464,
    code: 'FCL-ATL',
    name: 'FCL Braves',
    shortName: 'FCL Braves',
    colorHex: '#CE1141',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 144,
  },
  {
    teamPk: 605,
    code: 'DSL-ATL',
    name: 'DSL Braves',
    shortName: 'DSL Braves',
    colorHex: '#CE1141',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 144,
  },
  {
    teamPk: 121,
    code: 'NYM',
    name: 'New York Mets',
    shortName: 'Mets',
    colorHex: '#002D72',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 121,
  },
  {
    teamPk: 552,
    code: 'SYR',
    name: 'Syracuse Mets',
    shortName: 'Mets',
    colorHex: '#002D72',
    sportId: MlbSportId.AAA,
    orgPk: 121,
  },
  {
    teamPk: 505,
    code: 'BIN',
    name: 'Binghamton Rumble Ponies',
    shortName: 'Rumble Ponies',
    colorHex: '#00205B',
    sportId: MlbSportId.AA,
    orgPk: 121,
  },
  {
    teamPk: 453,
    code: 'BRK',
    name: 'Brooklyn Cyclones',
    shortName: 'Cyclones',
    colorHex: '#002D72',
    sportId: MlbSportId.HighA,
    orgPk: 121,
  },
  {
    teamPk: 507,
    code: 'SL',
    name: 'St. Lucie Mets',
    shortName: 'Mets',
    colorHex: '#002D72',
    sportId: MlbSportId.SingleA,
    orgPk: 121,
  },
  {
    teamPk: 468,
    code: 'FCL-NYM',
    name: 'FCL Mets',
    shortName: 'FCL Mets',
    colorHex: '#002D72',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 121,
  },
  {
    teamPk: 620,
    code: 'DSL-NYM-BLU',
    name: 'DSL Mets Blue',
    shortName: 'DSL Mets Blue',
    colorHex: '#002D72',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 121,
  },
  {
    teamPk: 2117,
    code: 'DSL-NYM-ORG',
    name: 'DSL Mets Orange',
    shortName: 'DSL Mets Orange',
    colorHex: '#002D72',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 121,
  },
  {
    teamPk: 143,
    code: 'PHI',
    name: 'Philadelphia Phillies',
    shortName: 'Phillies',
    colorHex: '#E81828',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 143,
  },
  {
    teamPk: 1410,
    code: 'LV',
    name: 'Lehigh Valley IronPigs',
    shortName: 'IronPigs',
    colorHex: '#C8102E',
    sportId: MlbSportId.AAA,
    orgPk: 143,
  },
  {
    teamPk: 522,
    code: 'REA',
    name: 'Reading Fightin Phils',
    shortName: 'Fightin Phils',
    colorHex: '#C8102E',
    sportId: MlbSportId.AA,
    orgPk: 143,
  },
  {
    teamPk: 427,
    code: 'JS',
    name: 'Jersey Shore BlueClaws',
    shortName: 'BlueClaws',
    colorHex: '#00205B',
    sportId: MlbSportId.HighA,
    orgPk: 143,
  },
  {
    teamPk: 566,
    code: 'CLW',
    name: 'Clearwater Threshers',
    shortName: 'Threshers',
    colorHex: '#E81828',
    sportId: MlbSportId.SingleA,
    orgPk: 143,
  },
  {
    teamPk: 469,
    code: 'FCL-PHI',
    name: 'FCL Phillies',
    shortName: 'FCL Phillies',
    colorHex: '#E81828',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 143,
  },
  {
    teamPk: 623,
    code: 'DSL-PHI-RED',
    name: 'DSL Phillies Red',
    shortName: 'DSL Phillies Red',
    colorHex: '#E81828',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 143,
  },
  {
    teamPk: 5085,
    code: 'DSL-PHI-WHT',
    name: 'DSL Phillies White',
    shortName: 'DSL Phillies White',
    colorHex: '#E81828',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 143,
  },
  {
    teamPk: 146,
    code: 'MIA',
    name: 'Miami Marlins',
    shortName: 'Marlins',
    colorHex: '#00A3E0',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 146,
  },
  {
    teamPk: 564,
    code: 'JAX',
    name: 'Jacksonville Jumbo Shrimp',
    shortName: 'Jumbo Shrimp',
    colorHex: '#FF6F61',
    sportId: MlbSportId.AAA,
    orgPk: 146,
  },
  {
    teamPk: 4124,
    code: 'PEN',
    name: 'Pensacola Blue Wahoos',
    shortName: 'Blue Wahoos',
    colorHex: '#00205B',
    sportId: MlbSportId.AA,
    orgPk: 146,
  },
  {
    teamPk: 554,
    code: 'BEL',
    name: 'Beloit Sky Carp',
    shortName: 'Sky Carp',
    colorHex: '#00A3E0',
    sportId: MlbSportId.HighA,
    orgPk: 146,
  },
  {
    teamPk: 479,
    code: 'JUP',
    name: 'Jupiter Hammerheads',
    shortName: 'Hammerheads',
    colorHex: '#C8102E',
    sportId: MlbSportId.SingleA,
    orgPk: 146,
  },
  {
    teamPk: 467,
    code: 'FCL-MIA',
    name: 'FCL Marlins',
    shortName: 'FCL Marlins',
    colorHex: '#00A3E0',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 146,
  },
  {
    teamPk: 619,
    code: 'DSL-MIA',
    name: 'DSL Marlins',
    shortName: 'DSL Marlins',
    colorHex: '#00A3E0',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 146,
  },
  {
    teamPk: 2127,
    code: 'DSL-MIA-2',
    name: 'DSL Miami',
    shortName: 'DSL Miami',
    colorHex: '#00A3E0',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 146,
  },
  {
    teamPk: 120,
    code: 'WSH',
    name: 'Washington Nationals',
    shortName: 'Nationals',
    colorHex: '#AB0003',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 120,
  },
  {
    teamPk: 534,
    code: 'ROC',
    name: 'Rochester Red Wings',
    shortName: 'Red Wings',
    colorHex: '#C8102E',
    sportId: MlbSportId.AAA,
    orgPk: 120,
  },
  {
    teamPk: 547,
    code: 'HAR',
    name: 'Harrisburg Senators',
    shortName: 'Senators',
    colorHex: '#AB0003',
    sportId: MlbSportId.AA,
    orgPk: 120,
  },
  {
    teamPk: 426,
    code: 'WIL',
    name: 'Wilmington Blue Rocks',
    shortName: 'Blue Rocks',
    colorHex: '#00205B',
    sportId: MlbSportId.HighA,
    orgPk: 120,
  },
  {
    teamPk: 436,
    code: 'FBG',
    name: 'Fredericksburg Nationals',
    shortName: 'FredNats',
    colorHex: '#AB0003',
    sportId: MlbSportId.SingleA,
    orgPk: 120,
  },
  {
    teamPk: 466,
    code: 'FCL-WSH',
    name: 'FCL Nationals',
    shortName: 'FCL Nationals',
    colorHex: '#AB0003',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 120,
  },
  {
    teamPk: 1270,
    code: 'DSL-WSH',
    name: 'DSL Nationals',
    shortName: 'DSL Nationals',
    colorHex: '#AB0003',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 120,
  },
  {
    teamPk: 158,
    code: 'MIL',
    name: 'Milwaukee Brewers',
    shortName: 'Brewers',
    colorHex: '#12284B',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 158,
  },
  {
    teamPk: 556,
    code: 'NAS',
    name: 'Nashville Sounds',
    shortName: 'Sounds',
    colorHex: '#C8102E',
    sportId: MlbSportId.AAA,
    orgPk: 158,
  },
  {
    teamPk: 5015,
    code: 'BIL',
    name: 'Biloxi Shuckers',
    shortName: 'Shuckers',
    colorHex: '#00205B',
    sportId: MlbSportId.AA,
    orgPk: 158,
  },
  {
    teamPk: 572,
    code: 'WIS',
    name: 'Wisconsin Timber Rattlers',
    shortName: 'Timber Rattlers',
    colorHex: '#006341',
    sportId: MlbSportId.HighA,
    orgPk: 158,
  },
  {
    teamPk: 249,
    code: 'CAR',
    name: 'Carolina Mudcats',
    shortName: 'Mudcats',
    colorHex: '#C8102E',
    sportId: MlbSportId.SingleA,
    orgPk: 158,
  },
  {
    teamPk: 406,
    code: 'ACL-MIL',
    name: 'ACL Brewers',
    shortName: 'ACL Brewers',
    colorHex: '#12284B',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 158,
  },
  {
    teamPk: 607,
    code: 'DSL-MIL-BLU',
    name: 'DSL Brewers Blue',
    shortName: 'DSL Brewers Blue',
    colorHex: '#12284B',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 158,
  },
  {
    teamPk: 2101,
    code: 'DSL-MIL-GLD',
    name: 'DSL Brewers Gold',
    shortName: 'DSL Brewers Gold',
    colorHex: '#12284B',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 158,
  },
  {
    teamPk: 138,
    code: 'STL',
    name: 'St. Louis Cardinals',
    shortName: 'Cardinals',
    colorHex: '#C41E3A',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 138,
  },
  {
    teamPk: 235,
    code: 'MEM',
    name: 'Memphis Redbirds',
    shortName: 'Redbirds',
    colorHex: '#C41E3A',
    sportId: MlbSportId.AAA,
    orgPk: 138,
  },
  {
    teamPk: 440,
    code: 'SPR',
    name: 'Springfield Cardinals',
    shortName: 'Cardinals',
    colorHex: '#C41E3A',
    sportId: MlbSportId.AA,
    orgPk: 138,
  },
  {
    teamPk: 443,
    code: 'PEO',
    name: 'Peoria Chiefs',
    shortName: 'Chiefs',
    colorHex: '#C41E3A',
    sportId: MlbSportId.HighA,
    orgPk: 138,
  },
  {
    teamPk: 279,
    code: 'PB',
    name: 'Palm Beach Cardinals',
    shortName: 'Cardinals',
    colorHex: '#C41E3A',
    sportId: MlbSportId.SingleA,
    orgPk: 138,
  },
  {
    teamPk: 1370,
    code: 'FCL-STL',
    name: 'FCL Cardinals',
    shortName: 'FCL Cardinals',
    colorHex: '#C41E3A',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 138,
  },
  {
    teamPk: 608,
    code: 'DSL-STL',
    name: 'DSL Cardinals',
    shortName: 'DSL Cardinals',
    colorHex: '#C41E3A',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 138,
  },
  {
    teamPk: 112,
    code: 'CHC',
    name: 'Chicago Cubs',
    shortName: 'Cubs',
    colorHex: '#0E3386',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 112,
  },
  {
    teamPk: 451,
    code: 'IOW',
    name: 'Iowa Cubs',
    shortName: 'Cubs',
    colorHex: '#0E3386',
    sportId: MlbSportId.AAA,
    orgPk: 112,
  },
  {
    teamPk: 553,
    code: 'TEN',
    name: 'Knoxville Smokies',
    shortName: 'Smokies',
    colorHex: '#00205B',
    sportId: MlbSportId.AA,
    orgPk: 112,
  },
  {
    teamPk: 550,
    code: 'SB',
    name: 'South Bend Cubs',
    shortName: 'Cubs',
    colorHex: '#0E3386',
    sportId: MlbSportId.HighA,
    orgPk: 112,
  },
  {
    teamPk: 521,
    code: 'MB',
    name: 'Myrtle Beach Pelicans',
    shortName: 'Pelicans',
    colorHex: '#00A3E0',
    sportId: MlbSportId.SingleA,
    orgPk: 112,
  },
  {
    teamPk: 407,
    code: 'ACL-CHC',
    name: 'ACL Cubs',
    shortName: 'ACL Cubs',
    colorHex: '#0E3386',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 112,
  },
  {
    teamPk: 609,
    code: 'DSL-CHC-BLU',
    name: 'DSL Cubs Blue',
    shortName: 'DSL Cubs Blue',
    colorHex: '#0E3386',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 112,
  },
  {
    teamPk: 2270,
    code: 'DSL-CHC-RED',
    name: 'DSL Cubs Red',
    shortName: 'DSL Cubs Red',
    colorHex: '#0E3386',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 112,
  },
  {
    teamPk: 113,
    code: 'CIN',
    name: 'Cincinnati Reds',
    shortName: 'Reds',
    colorHex: '#C6011F',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 113,
  },
  {
    teamPk: 416,
    code: 'LOU',
    name: 'Louisville Bats',
    shortName: 'Bats',
    colorHex: '#4B2E83',
    sportId: MlbSportId.AAA,
    orgPk: 113,
  },
  {
    teamPk: 498,
    code: 'CHA',
    name: 'Chattanooga Lookouts',
    shortName: 'Lookouts',
    colorHex: '#C6011F',
    sportId: MlbSportId.AA,
    orgPk: 113,
  },
  {
    teamPk: 459,
    code: 'DAY',
    name: 'Dayton Dragons',
    shortName: 'Dragons',
    colorHex: '#C8102E',
    sportId: MlbSportId.HighA,
    orgPk: 113,
  },
  {
    teamPk: 450,
    code: 'DYT',
    name: 'Daytona Tortugas',
    shortName: 'Tortugas',
    colorHex: '#006341',
    sportId: MlbSportId.SingleA,
    orgPk: 113,
  },
  {
    teamPk: 3430,
    code: 'ACL-CIN',
    name: 'ACL Reds',
    shortName: 'ACL Reds',
    colorHex: '#C6011F',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 113,
  },
  {
    teamPk: 628,
    code: 'DSL-CIN',
    name: 'DSL Reds',
    shortName: 'DSL Reds',
    colorHex: '#C6011F',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 113,
  },
  {
    teamPk: 2412,
    code: 'DSL-CIN-2',
    name: 'DSL Rojos',
    shortName: 'DSL Rojos',
    colorHex: '#C6011F',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 113,
  },
  {
    teamPk: 134,
    code: 'PIT',
    name: 'Pittsburgh Pirates',
    shortName: 'Pirates',
    colorHex: '#27251F',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 134,
  },
  {
    teamPk: 484,
    code: 'IND',
    name: 'Indianapolis Indians',
    shortName: 'Indians',
    colorHex: '#C8102E',
    sportId: MlbSportId.AAA,
    orgPk: 134,
  },
  {
    teamPk: 452,
    code: 'ALT',
    name: 'Altoona Curve',
    shortName: 'Curve',
    colorHex: '#C8102E',
    sportId: MlbSportId.AA,
    orgPk: 134,
  },
  {
    teamPk: 477,
    code: 'GRE',
    name: 'Greensboro Grasshoppers',
    shortName: 'Grasshoppers',
    colorHex: '#006341',
    sportId: MlbSportId.HighA,
    orgPk: 134,
  },
  {
    teamPk: 3390,
    code: 'BRA',
    name: 'Bradenton Marauders',
    shortName: 'Marauders',
    colorHex: '#27251F',
    sportId: MlbSportId.SingleA,
    orgPk: 134,
  },
  {
    teamPk: 470,
    code: 'FCL-PIT',
    name: 'FCL Pirates',
    shortName: 'FCL Pirates',
    colorHex: '#27251F',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.FCL,
    orgPk: 134,
  },
  {
    teamPk: 624,
    code: 'DSL-PIT-BLK',
    name: 'DSL Pirates Black',
    shortName: 'DSL Pirates Black',
    colorHex: '#27251F',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 134,
  },
  {
    teamPk: 4404,
    code: 'DSL-PIT-GLD',
    name: 'DSL Pirates Gold',
    shortName: 'DSL Pirates Gold',
    colorHex: '#27251F',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 134,
  },
  {
    teamPk: 119,
    code: 'LAD',
    name: 'Los Angeles Dodgers',
    shortName: 'Dodgers',
    colorHex: '#005A9C',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 119,
  },
  {
    teamPk: 238,
    code: 'OKC',
    name: 'Oklahoma City Comets',
    shortName: 'Comets',
    colorHex: '#005A9C',
    sportId: MlbSportId.AAA,
    orgPk: 119,
  },
  {
    teamPk: 260,
    code: 'TUL',
    name: 'Tulsa Drillers',
    shortName: 'Drillers',
    colorHex: '#002D72',
    sportId: MlbSportId.AA,
    orgPk: 119,
  },
  {
    teamPk: 456,
    code: 'GL',
    name: 'Great Lakes Loons',
    shortName: 'Loons',
    colorHex: '#005A9C',
    sportId: MlbSportId.HighA,
    orgPk: 119,
  },
  {
    teamPk: 526,
    code: 'RC',
    name: 'Rancho Cucamonga Quakes',
    shortName: 'Quakes',
    colorHex: '#00843D',
    sportId: MlbSportId.SingleA,
    orgPk: 119,
  },
  {
    teamPk: 5427,
    code: 'ACL-LAD',
    name: 'ACL Dodgers',
    shortName: 'ACL Dodgers',
    colorHex: '#005A9C',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 119,
  },
  {
    teamPk: 611,
    code: 'DSL-LAD-BAU',
    name: 'DSL LAD Bautista',
    shortName: 'DSL LAD Bautista',
    colorHex: '#005A9C',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 119,
  },
  {
    teamPk: 612,
    code: 'DSL-LAD-MEG',
    name: 'DSL LAD Mega',
    shortName: 'DSL LAD Mega',
    colorHex: '#005A9C',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 119,
  },
  {
    teamPk: 135,
    code: 'SD',
    name: 'San Diego Padres',
    shortName: 'Padres',
    colorHex: '#2F241D',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 135,
  },
  {
    teamPk: 4904,
    code: 'EP',
    name: 'El Paso Chihuahuas',
    shortName: 'Chihuahuas',
    colorHex: '#C8102E',
    sportId: MlbSportId.AAA,
    orgPk: 135,
  },
  {
    teamPk: 510,
    code: 'SA',
    name: 'San Antonio Missions',
    shortName: 'Missions',
    colorHex: '#00205B',
    sportId: MlbSportId.AA,
    orgPk: 135,
  },
  {
    teamPk: 584,
    code: 'FW',
    name: 'Fort Wayne TinCaps',
    shortName: 'TinCaps',
    colorHex: '#C8102E',
    sportId: MlbSportId.HighA,
    orgPk: 135,
  },
  {
    teamPk: 103,
    code: 'LE',
    name: 'Lake Elsinore Storm',
    shortName: 'Storm',
    colorHex: '#FFD100',
    sportId: MlbSportId.SingleA,
    orgPk: 135,
  },
  {
    teamPk: 410,
    code: 'ACL-SD',
    name: 'ACL Padres',
    shortName: 'ACL Padres',
    colorHex: '#2F241D',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 135,
  },
  {
    teamPk: 622,
    code: 'DSL-SD-BRN',
    name: 'DSL Padres Brown',
    shortName: 'DSL Padres Brown',
    colorHex: '#2F241D',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 135,
  },
  {
    teamPk: 2122,
    code: 'DSL-SD-GLD',
    name: 'DSL Padres Gold',
    shortName: 'DSL Padres Gold',
    colorHex: '#2F241D',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 135,
  },
  {
    teamPk: 137,
    code: 'SF',
    name: 'San Francisco Giants',
    shortName: 'Giants',
    colorHex: '#FD5A1E',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 137,
  },
  {
    teamPk: 105,
    code: 'SAC',
    name: 'Sacramento River Cats',
    shortName: 'River Cats',
    colorHex: '#C8102E',
    sportId: MlbSportId.AAA,
    orgPk: 137,
  },
  {
    teamPk: 3410,
    code: 'RIC',
    name: 'Richmond Flying Squirrels',
    shortName: 'Flying Squirrels',
    colorHex: '#8B4513',
    sportId: MlbSportId.AA,
    orgPk: 137,
  },
  {
    teamPk: 461,
    code: 'EUG',
    name: 'Eugene Emeralds',
    shortName: 'Emeralds',
    colorHex: '#006341',
    sportId: MlbSportId.HighA,
    orgPk: 137,
  },
  {
    teamPk: 476,
    code: 'SJ',
    name: 'San Jose Giants',
    shortName: 'Giants',
    colorHex: '#FD5A1E',
    sportId: MlbSportId.SingleA,
    orgPk: 137,
  },
  {
    teamPk: 408,
    code: 'ACL-SF',
    name: 'ACL Giants',
    shortName: 'ACL Giants',
    colorHex: '#FD5A1E',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 137,
  },
  {
    teamPk: 615,
    code: 'DSL-SF-ORG',
    name: 'DSL Giants Orange',
    shortName: 'DSL Giants Orange',
    colorHex: '#FD5A1E',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 137,
  },
  {
    teamPk: 2134,
    code: 'DSL-SF-BLK',
    name: 'DSL Giants Black',
    shortName: 'DSL Giants Black',
    colorHex: '#FD5A1E',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 137,
  },
  {
    teamPk: 115,
    code: 'COL',
    name: 'Colorado Rockies',
    shortName: 'Rockies',
    colorHex: '#33006F',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 115,
  },
  {
    teamPk: 342,
    code: 'ABQ',
    name: 'Albuquerque Isotopes',
    shortName: 'Isotopes',
    colorHex: '#C8102E',
    sportId: MlbSportId.AAA,
    orgPk: 115,
  },
  {
    teamPk: 538,
    code: 'HFD',
    name: 'Hartford Yard Goats',
    shortName: 'Yard Goats',
    colorHex: '#00205B',
    sportId: MlbSportId.AA,
    orgPk: 115,
  },
  {
    teamPk: 486,
    code: 'SPO',
    name: 'Spokane Indians',
    shortName: 'Indians',
    colorHex: '#C8102E',
    sportId: MlbSportId.HighA,
    orgPk: 115,
  },
  {
    teamPk: 259,
    code: 'FRE',
    name: 'Fresno Grizzlies',
    shortName: 'Grizzlies',
    colorHex: '#C8102E',
    sportId: MlbSportId.SingleA,
    orgPk: 115,
  },
  {
    teamPk: 1994,
    code: 'ACL-COL',
    name: 'ACL Rockies',
    shortName: 'ACL Rockies',
    colorHex: '#33006F',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 115,
  },
  {
    teamPk: 629,
    code: 'DSL-COL',
    name: 'DSL Rockies',
    shortName: 'DSL Rockies',
    colorHex: '#33006F',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 115,
  },
  {
    teamPk: 2131,
    code: 'DSL-COL-2',
    name: 'DSL Colorado',
    shortName: 'DSL Colorado',
    colorHex: '#33006F',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 115,
  },
  {
    teamPk: 109,
    code: 'ARI',
    name: 'Arizona Diamondbacks',
    shortName: 'Diamondbacks',
    colorHex: '#A71930',
    sportId: MlbSportId.MLB,
    isOrganization: true,
    orgPk: 109,
  },
  {
    teamPk: 2310,
    code: 'RNO',
    name: 'Reno Aces',
    shortName: 'Aces',
    colorHex: '#C8102E',
    sportId: MlbSportId.AAA,
    orgPk: 109,
  },
  {
    teamPk: 5368,
    code: 'AMA',
    name: 'Amarillo Sod Poodles',
    shortName: 'Sod Poodles',
    colorHex: '#FFD100',
    sportId: MlbSportId.AA,
    orgPk: 109,
  },
  {
    teamPk: 419,
    code: 'HIL',
    name: 'Hillsboro Hops',
    shortName: 'Hops',
    colorHex: '#006341',
    sportId: MlbSportId.HighA,
    orgPk: 109,
  },
  {
    teamPk: 516,
    code: 'VIS',
    name: 'Visalia Rawhide',
    shortName: 'Rawhide',
    colorHex: '#C8102E',
    sportId: MlbSportId.SingleA,
    orgPk: 109,
  },
  {
    teamPk: 1991,
    code: 'ACL-ARI',
    name: 'ACL D-backs',
    shortName: 'ACL D-backs',
    colorHex: '#A71930',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.ACL,
    orgPk: 109,
  },
  {
    teamPk: 610,
    code: 'DSL-ARI-BLK',
    name: 'DSL Arizona Black',
    shortName: 'DSL Arizona Black',
    colorHex: '#A71930',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 109,
  },
  {
    teamPk: 5087,
    code: 'DSL-ARI-RED',
    name: 'DSL Arizona Red',
    shortName: 'DSL Arizona Red',
    colorHex: '#A71930',
    sportId: MlbSportId.Rookie,
    rookieLeague: RookieLeague.DSL,
    orgPk: 109,
  },
];

export const MLB_TEAMS_DICT = ArrayHelper.firstBy(MLB_TEAMS, 'teamPk');

export const GAME_STATUS_DISABLE_ACTION_MSG =
  'This action is disabled while your team is in a game.';
